import { raw } from './Raw';

/**
  * 
  *  created by AHMED HAYEL 
  *
  */

export class raws {
    raws: raw[];
    count: number;
    constructor() {
        this.count = 0;
    }
}


// WEBPACK FOOTER //
// ./src/app/Model/Raws.ts